export const tiposLicitacao = [
    { value: 1, text: 'Pregão' },
    { value: 2, text: 'Convite' },
    { value: 3, text: 'Concorrência' },
    { value: 4, text: 'Dispensa' },
    { value: 5, text: 'Inexibilidade' },
    { value: 6, text: 'Pregão Eletrônico' },
    { value: 7, text: 'Concurso' },
    { value: 8, text: 'Termo de Cadastramento' },
    { value: 9, text: 'Chamada Pública' }
]
